export default function fillArray<T>(len: number, generator: (index: number) => T): Array<T> {
  return Array.from(Array(len), (_, index) => generator(index));
}
